import { Link } from "@/i18n/navigation";

const PricingWilconAI = () => {
  return (
    <div
      className={
        "mt-[20px] w-full bg-[#132456] px-[16px] pb-[20px] pt-[28px] sm:pb-[38px] sm:pl-[40px] sm:pr-[30px] sm:pt-[46px]"
      }
    >
      <h2
        className={
          "text-title1 font-[800] leading-[40px] text-white sm:text-heading3"
        }
      >
        고객사가
        <br />
        Winging을 선택하는 이유
      </h2>
      <p className={"mt-[12px] text-label2 text-blue-100 opacity-50"}>
        AI 전문가로 구성된 WilconAI에서 <br className={"block sm:hidden"} />
        Winging을 만들고 있습니다.
      </p>
      <div
        className={
          "mt-[18px] flex w-full items-center justify-between gap-[12px] sm:mt-[18px] sm:items-end"
        }
      >
        <Link
          href={
            "https://cdn.winging.app/static/builder/%EC%9C%99%EC%9E%89%EC%84%9C%EB%B9%84%EC%8A%A4_%EC%86%8C%EA%B0%9C%EC%9E%90%EB%A3%8C.pdf"
          }
          target={"_blank"}
          className={
            "flex items-center justify-center rounded-md bg-white px-[32px] py-[10px] text-label2 font-[700] text-[#132456]"
          }
        >
          소개자료 보기
        </Link>

        <Link
          href={"https://wilcon.ai"}
          target={"_blank"}
          className={
            "flex items-center gap-[2px] text-title2 font-[800] text-white"
          }
        >
          <span>홈페이지 가기</span>
          <svg
            width="32"
            height="26"
            viewBox="0 0 32 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_1332_2174)">
              <path
                d="M10.668 5.41602V20.5827L25.3346 12.9993L10.668 5.41602Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_1332_2174">
                <rect width="32" height="26" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
      </div>
    </div>
  );
};
export default PricingWilconAI;
